// extracted by mini-css-extract-plugin
export default {"container":"sort-menu_container__-1pdk"};